import { Link } from 'react-router-dom';
import {
  LegalEmailLink,
  LegalList,
  LegalPageLayout,
  LegalParagraph,
  LegalSection,
  LegalTable,
} from '@/pages/legal/LegalPageLayout';

export default function PrivacyPage() {
  return (
    <LegalPageLayout
      version="Versão 2.0"
      updatedAt="Atualizada em 07/05/2026"
      title="Política de Privacidade — Culture Monitor"
    >
      <LegalSection title="1. Introdução e Identificação do Controlador">
        <LegalParagraph>
          A privacidade é importante para a <span className="italic">live.</span> Esta Política de
          Privacidade descreve como coletamos, utilizamos, armazenamos e protegemos os dados pessoais
          dos usuários do Culture Monitor, em conformidade com a Lei Geral de Proteção de Dados
          Pessoais (Lei nº 13.709/2018 — LGPD) e demais normas aplicáveis.
        </LegalParagraph>
        <LegalParagraph>
          Esta política se aplica ao Culture Monitor, plataforma B2B desenvolvida e operada pela{' '}
          <span className="italic">live.</span>, que oferece relatórios e insights culturais a
          empresas contratantes.
        </LegalParagraph>
        <p className="font-semibold text-gray-600">Controlador dos Dados:</p>
        <LegalList
          items={[
            <>
              <strong>Razão Social:</strong> LIVE MARKETING DE DISSEMINACAO LTDA
            </>,
            <>
              <strong>CNPJ:</strong> 07.759.470/0001-82
            </>,
            <>
              <strong>Endereço:</strong> Av. Brig. Faria Lima 1572 - Jardim Paulistano - CEP:
              01451-917 - São Paulo / SP
            </>,
            <>
              <strong>Contato:</strong> <LegalEmailLink email="dpo@culturemonitor.com" />
            </>,
          ]}
        />
        <p className="font-semibold text-gray-600">Encarregado de Dados (DPO):</p>
        <LegalList
          items={[
            <>
              <strong>Nome:</strong> Lucas Polato
            </>,
            <>
              <strong>E-mail:</strong> <LegalEmailLink email="dpo@culturemonitor.com" />
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="2. Sobre o Culture Monitor">
        <LegalParagraph>
          O Culture Monitor é um produto B2B que transforma sinais culturais em insights
          estratégicos para marcas, entregues por meio de relatórios digitais em ambiente logado. O
          acesso é realizado por convite, destinado a usuários vinculados a empresas que contratam a{' '}
          <span className="italic">live.</span>
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="3. Quais Dados Coletamos">
        <LegalParagraph>
          Coletamos apenas os dados pessoais mínimos necessários para as finalidades declaradas
          nesta política:
        </LegalParagraph>
        <LegalParagraph>
          <strong>3.1. Dados Cadastrais:</strong> Nome completo, e-mail corporativo, empresa e demais
          informações fornecidas no momento do cadastro.
        </LegalParagraph>
        <LegalParagraph>
          <strong>3.2. Dados de Acesso e Logs:</strong> Endereço IP, identificadores de dispositivo,
          tipo de navegador, sistema operacional, datas e horários de acesso e registros de
          autenticação.
        </LegalParagraph>
        <LegalParagraph>
          <strong>3.3. Dados Comportamentais:</strong> Cliques, navegação, tempo de permanência em
          páginas, leitura de seções do report e interações com a plataforma, coletados via PostHog,
          sujeitos a consentimento.
        </LegalParagraph>
        <LegalParagraph>
          <strong>3.4. Cookies e Tecnologias Similares:</strong> Cookies essenciais, funcionais e
          analíticos, gerenciados via CookieYes, conforme descrito na Seção 7.
        </LegalParagraph>
        <LegalParagraph>
          Você é livre para recusar ou revogar o consentimento a qualquer momento, ciente de que
          isso pode limitar determinadas funcionalidades da plataforma.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="4. Para que Utilizamos os Dados (Finalidades e Bases Legais)">
        <LegalParagraph>
          Tratamos dados pessoais de acordo com finalidades específicas e bases legais previstas na
          LGPD:
        </LegalParagraph>
        <LegalTable
          headers={['Categoria de Dados', 'Finalidade', 'Base Legal (LGPD, art. 7º)']}
          rows={[
            [
              'Cadastrais (nome, e-mail corporativo, empresa)',
              'Autenticação, gestão de conta e comunicação operacional',
              'Execução de contrato (art. 7º, V)',
            ],
            [
              'Acesso e logs (IP, dispositivo, navegador, timestamps)',
              'Segurança da plataforma, prevenção a fraude e cumprimento legal',
              'Legítimo interesse e cumprimento de obrigação legal (Marco Civil da Internet)',
            ],
            [
              'Comportamentais (cliques, navegação, leitura de seções do report — via PostHog)',
              'Mensuração de uso e melhoria contínua do produto',
              'Consentimento (art. 7º, I), coletado via banner CookieYes',
            ],
            [
              'E-mail e contato',
              'Envio de relatórios, comunicados e suporte',
              'Execução de contrato (art. 7º, V)',
            ],
          ]}
        />
      </LegalSection>

      <LegalSection title="5. Com Quem Compartilhamos Dados (Subprocessadores)">
        <LegalParagraph>
          Para operar o Culture Monitor, contamos com fornecedores e parceiros (Operadores nos termos
          da LGPD) que tratam dados pessoais sob nossas instruções, sujeitos a obrigações de
          confidencialidade e segurança:
        </LegalParagraph>
        <LegalTable
          headers={[
            'Subprocessador',
            'Finalidade',
            'Localização',
            'Transferência Internacional',
          ]}
          rows={[
            [
              'PostHog',
              'Analytics de produto e mensuração de comportamento',
              'EUA / UE',
              'Sim',
            ],
            [
              'CookieYes',
              'Gestão de consentimento de cookies',
              'Índia / UE',
              'Sim',
            ],
            [
              'netlify',
              'Hospedagem da aplicação e banco de dados',
              'EUA',
              'Sim',
            ],
          ]}
        />
        <LegalParagraph>
          Não compartilhamos informações pessoalmente identificáveis publicamente nem com terceiros
          para fins comerciais ou publicitários, salvo quando exigido por lei ou mediante
          consentimento expresso.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="6. Transferência Internacional de Dados">
        <LegalParagraph>
          Alguns subprocessadores possuem infraestrutura fora do Brasil. Nesses casos, a
          transferência internacional ocorre com fundamento nas hipóteses do art. 33 da LGPD,
          observando garantias contratuais, padrões de segurança e cláusulas contratuais padrão.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="7. Cookies e Tecnologias Similares">
        <LegalList
          items={[
            <>
              <strong>Essenciais:</strong> necessários para autenticação e funcionamento básico da
              plataforma; não requerem consentimento.
            </>,
            <>
              <strong>Funcionais:</strong> memorizam preferências e personalizam a experiência;
              coletados mediante consentimento.
            </>,
            <>
              <strong>Analíticos:</strong> medem uso e desempenho para melhoria do produto; coletados
              mediante consentimento.
            </>,
          ]}
        />
        <LegalParagraph>
          Não utilizamos cookies de marketing ou publicidade.
        </LegalParagraph>
        <LegalParagraph>
          Você pode gerenciar suas preferências a qualquer momento pelo banner de consentimento
          CookieYes ou pelo link &quot;Preferências de cookies&quot; disponível no rodapé da
          plataforma. A revogação do consentimento não afeta o acesso às funcionalidades essenciais.
        </LegalParagraph>
        <LegalParagraph>
          Consulte também a{' '}
          <Link to="/cookies" className="text-blue-600 underline">
            Política de Cookies
          </Link>
          .
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="8. Por Quanto Tempo Retemos os Dados">
        <LegalParagraph>
          Mantemos dados pessoais apenas pelo tempo necessário para as finalidades declaradas:
        </LegalParagraph>
        <LegalList
          items={[
            <>
              <strong>Dados cadastrais e de conta ativa:</strong> durante a vigência do contrato e
              pelo prazo prescricional aplicável (em geral, até 5 anos após o encerramento).
            </>,
            <>
              <strong>Dados de acesso e logs:</strong> 6 meses, conforme o art. 15 do Marco Civil da
              Internet (Lei nº 12.965/2014).
            </>,
            <>
              <strong>Dados comportamentais identificáveis:</strong> até 24 meses; após esse período,
              são anonimizados ou eliminados.
            </>,
            <>
              <strong>Dados anonimizados ou agregados:</strong> podem ser mantidos indefinidamente
              para fins estatísticos e de melhoria do produto.
            </>,
            <>
              <strong>Após exclusão da conta:</strong> até 30 dias para eliminação de backups, salvo
              obrigação legal de retenção.
            </>,
          ]}
        />
        <LegalParagraph>
          Os procedimentos de descarte seguem a Política Interna de Segurança da Informação da{' '}
          <span className="italic">live.</span>
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="9. Como Protegemos os Dados">
        <LegalParagraph>
          Adotamos medidas técnicas e organizacionais para prevenir perda, roubo, acesso não
          autorizado, divulgação, cópia, uso ou modificação indevida dos dados pessoais, incluindo,
          no mínimo: criptografia TLS em trânsito, controle de acesso por autenticação, monitoramento
          de eventos de segurança, princípio do menor privilégio e processos documentados de gestão
          de incidentes.
        </LegalParagraph>
        <LegalParagraph>
          Em caso de incidente de segurança que possa acarretar risco ou dano relevante aos
          titulares, notificaremos a ANPD e os titulares afetados em prazo razoável, conforme o art.
          48 da LGPD.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="10. Direitos do Titular e Como Exercê-los">
        <LegalParagraph>Nos termos da LGPD, você tem direito a:</LegalParagraph>
        <LegalList
          items={[
            'Confirmar a existência de tratamento e acessar seus dados pessoais;',
            'Corrigir dados incompletos, inexatos ou desatualizados;',
            'Solicitar anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade;',
            'Solicitar a eliminação de dados tratados com base no consentimento;',
            'Obter informação sobre entidades públicas e privadas com as quais a live. compartilhou dados;',
            'Ser informado sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa;',
            'Revogar o consentimento a qualquer momento;',
            'Solicitar revisão de decisões tomadas unicamente com base em tratamento automatizado, nos termos do art. 20 da LGPD.',
          ]}
        />
        <LegalParagraph>
          Para exercer seus direitos, entre em contato com o Encarregado de Dados pelo e-mail{' '}
          <LegalEmailLink email="dpo@culturemonitor.com" />. Responderemos em até 15 dias e poderemos
          solicitar informações adicionais para confirmar sua identidade.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="11. Uso de Inteligência Artificial">
        <LegalParagraph>
          O Culture Monitor pode utilizar sistemas de inteligência artificial e processamento
          automatizado para apoiar a geração de insights culturais e a organização de conteúdos.
          Esclarecemos que: (i) os outputs gerados por IA têm caráter de apoio analítico e não
          substituem o julgamento humano; (ii) não realizamos decisões automatizadas com efeitos
          legais ou impactos significativos sobre os titulares; (iii) caso venham a ocorrer,
          garantiremos o direito à revisão humana, nos termos do art. 20 da LGPD.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="12. Crianças e Adolescentes">
        <LegalParagraph>
          O Culture Monitor é um produto B2B destinado exclusivamente a usuários maiores de 18 anos
          vinculados a Empresas Contratantes. Não coletamos intencionalmente dados pessoais de
          crianças e adolescentes. Caso identifiquemos coleta inadvertida, os dados serão
          eliminados imediatamente.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="13. Links para Sites Externos">
        <LegalParagraph>
          Nossas plataformas podem conter links para sites externos não operados pela{' '}
          <span className="italic">live.</span> Não temos controle sobre o conteúdo e as práticas
          dessas plataformas e não nos responsabilizamos por suas respectivas políticas de
          privacidade.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="14. Atualizações desta Política">
        <LegalParagraph>
          Esta política pode ser atualizada periodicamente para refletir alterações legais,
          tecnológicas ou operacionais. A versão vigente estará sempre disponível nesta página de{' '}
          <Link to="/privacy" className="text-blue-600 underline">
            Política de Privacidade
          </Link>
          . Alterações materiais serão comunicadas por e-mail e/ou aviso destacado na plataforma com
          antecedência mínima de 15 dias antes de entrarem em vigor. O uso continuado dos serviços
          após as alterações constitui aceitação das práticas descritas.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="15. Contato">
        <LegalParagraph>
          Para dúvidas, solicitações ou exercício de direitos relacionados a esta política:
        </LegalParagraph>
        <LegalList
          items={[
            <>
              <strong>Encarregado de Dados (DPO):</strong> Lucas Polato —{' '}
              <LegalEmailLink email="dpo@culturemonitor.com" />
            </>,
            <>
              <strong>Suporte geral:</strong> <LegalEmailLink email="dpo@culturemonitor.com" />
            </>,
            <>
              <strong>Autoridade Nacional de Proteção de Dados (ANPD):</strong>{' '}
              <a
                href="https://www.gov.br/anpd"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline"
              >
                https://www.gov.br/anpd
              </a>
            </>,
          ]}
        />
      </LegalSection>
    </LegalPageLayout>
  );
}
